// src\components\Settings\Settings.js
import React from 'react';
import PropTypes from 'prop-types';
import './Settings.css'; // Importing the associated CSS file
import Dropdown from '../Dropdown/Dropdown'; // Importing the Dropdown component
import { CONSTANTS } from '../../utils/constants'; // Importing constants from the utility file

const Settings = ({
  profiles = [], // Default to an empty array
  currentProfile,
  font,
  fontSize,
  lineSpacing,
  colorScheme,
  handleProfileChange,
  saveProfile,
  setFont,
  setFontSize,
  setLineSpacing,
  setColorScheme,
  deleteProfile,
}) => (
  <div className="settings-container">
    <Dropdown label="Font" options={CONSTANTS.FONTS} value={font} onChange={setFont} />
    <Dropdown label="Font Size" options={CONSTANTS.SIZES} value={fontSize} onChange={setFontSize} />
    <Dropdown label="Line Spacing" options={CONSTANTS.LINE_SPACINGS} value={lineSpacing} onChange={setLineSpacing} />
    <Dropdown label="Color Scheme" options={CONSTANTS.COLOR_SCHEMES} value={colorScheme} onChange={setColorScheme} />
    <Dropdown
      label="Profile"
      options={profiles.map((p) => p.name)}
      value={currentProfile}
      onChange={handleProfileChange}
    />
    <button type="button" className="small-font" onClick={saveProfile}>Save Prfl</button>
    <button type="button" className="small-font" onClick={deleteProfile}>Del Prfl</button>
  </div>
);

Settings.propTypes = {
  profiles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      // Add more attributes here as needed
    }),
  ).isRequired,
  currentProfile: PropTypes.string.isRequired,
  font: PropTypes.string.isRequired,
  fontSize: PropTypes.string.isRequired,
  lineSpacing: PropTypes.string.isRequired,
  colorScheme: PropTypes.string.isRequired,
  handleProfileChange: PropTypes.func.isRequired,
  saveProfile: PropTypes.func.isRequired,
  setFont: PropTypes.func.isRequired,
  setFontSize: PropTypes.func.isRequired,
  setLineSpacing: PropTypes.func.isRequired,
  setColorScheme: PropTypes.func.isRequired,
  deleteProfile: PropTypes.func.isRequired,
};

export default Settings;
